import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import {  NgModule } from "@angular/core";
import { PagesComponent } from "./pages/pages.component";
import { PageNotMatchComponent } from "./pages/page-not-match/page-not-match.component";
import { AuthGuard } from "./auth.guard";


export const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      {
        path: "active-session",
        loadChildren: () =>
          import("./pages/active-session/active-session.module").then(
            (m) => m.ActiveSessionModule
          ),
        data: { breadcrumb: "active-session" },      
      },
      {
        path: "tax/relationship",
        loadChildren: () =>
          import("./pages/taxs-details/taxs-details.module").then(
            (m) => m.TaxDetailsModule
          ),
        data: { breadcrumb: "tax/relationship" },
        canActivate: [AuthGuard],
      },

      {
        path: "operational-dashboard",
        loadChildren: () =>
          import(
            "./pages/operational-dashboard/operational-dashboard.module"
          ).then((m) => m.OperationalDashboardModule),
        data: { breadcrumb: "operational-dashboard" },
        canActivate: [AuthGuard],
      },
      {
        path: "oig",
        loadChildren: () =>
          import(
            "./pages/oig/oig.module"
          ).then((m) => m.OigModule),
        data: { breadcrumb: "oig" },
        canActivate: [AuthGuard],
      },

      {
        path: "manage-service",
        loadChildren: () =>
          import("./pages/manage/manage.module").then(
            (m) => m.ManageModule
          ),
        data: { breadcrumb: "manage-service" },
        canActivate: [AuthGuard],
      },

      {
        path: "consultationsession",
        loadChildren: () =>
          import("./pages/consultation-services/consultation-services.module").then(
            (m) => m.ConsultationServicesModule
          ),
          canActivate: [AuthGuard],     
      },
      {
        path: "importpayment",
        loadChildren: () =>
          import("./pages/import-payment/import-payment.module").then(
            (m) => m.ImportPaymentModule
          ),
          canActivate: [AuthGuard],
        
      },
      
      {
        path: "events",
        loadChildren: () =>
          import("./pages/events/events.module").then(
            (m) => m.EventsModule
          ),
          canActivate: [AuthGuard],
        
      },
      {
        path: "referral",
        loadChildren: () =>
          import("./pages/referral/referral.module").then(
            (m) => m.ReferralModule
          ),
          canActivate: [AuthGuard],
        
      },
      
      {
        path: "schedule",
        loadChildren: () =>
          import("./pages/schedule/schedule.module").then(
            (m) => m.ScheduleModule
          ),
        data: { breadcrumb: "manage-service"},
        canActivate: [AuthGuard],
      },
      {
        path: "payroll",
        loadChildren: () =>
          import("./pages/payroll/payroll.module").then(
            (m) => m.PayrollModule),
        // data: { breadcrumb: "payroll" },       
        canActivate: [AuthGuard],
      },
      {
        path: "agency",
        loadChildren: () =>
          import("./pages/agency/agency.module").then((m) => m.AgencyModule),
        data: { breadcrumb: "agency" },
        canActivate: [AuthGuard],
      },
      {
        path: "agency-report",
        loadChildren: () =>
          import("./pages/agencyreport/agencyreport.module").then(
            (m) => m.AgencyreportModule
          ),
        data: { breadcrumb: "agencyreport"},
        canActivate: [AuthGuard],
      },
      {
        path: "Client",
        loadChildren: () =>
          import("./pages/client-parent/client-parent.module").then(
            (m) => m.ClientParentModule
          ),
        data: { breadcrumb: "Client" },
        canActivate: [AuthGuard],
      },

      {
        path: "qp-info",
        loadChildren: () =>
          import("./pages/qp-info/qp-info.module").then(
            (m) => m.QpInfoModule
          ),
        data: { breadcrumb: "qp-info"},
        canActivate: [AuthGuard],
      },
      {
        path: "Employee",
        loadChildren: () =>
          import("./pages/employee/employee.module").then(
            (m) => m.EmployeeModule
          ),
        data: { breadcrumb: "employee" },
        canActivate: [AuthGuard],
      },
      {
        path: "case-manager",
        loadChildren: () =>
          import("./pages/case-manager/case-manager.module").then(
            (m) => m.CaseManagerModule
          ),
        data: { breadcrumb: "case-manager" },
        canActivate: [AuthGuard],
      },
      {
        path: "clearing-house",
        loadChildren: () =>
          import("./pages/clearing-house/clearing-house.module").then(
            (m) => m.ClearingHouseModule
          ),
        data: { breadcrumb: "clearing-house" },
        canActivate: [AuthGuard],
      },
      {
        path: "care-coordinator",
        loadChildren: () =>
          import("./pages/care-coordinator/care-coordinator.module").then(
            (m) => m.CareCoordinatorModule
          ),
        data: { breadcrumb: "care-coordinator" },
        canActivate: [AuthGuard],
      },
      {
        path: "client-reports",
        loadChildren: () =>
          import("./pages/client-report/client-report.module").then(
            (m) => m.ClientReportModule
          ),
        data: { breadcrumb: "/client-reports"},
        canActivate: [AuthGuard],
      },
      {
        path: "discharge-codes",
        loadChildren: () =>
          import("./pages/discharge-codes/discharge-codes.module").then(
            (m) => m.DischargeCodesModule
          ),
        data: { breadcrumb: "discharge-codes" },
        canActivate: [AuthGuard],
      },
      {
        path: "eligibility",
        loadChildren: () =>
          import("./pages/eligibility270/eligibility270.module").then(
            (m) => m.Eligibility270Module
          ),
        data: { breadcrumb: "/eligibility"},
        canActivate: [AuthGuard],
      },

      {
        path: "list",
        loadChildren: () =>
          import("./pages/list/list.module").then((m) => m.ListModule),
        data: { breadcrumb: "list" },
        canActivate: [AuthGuard],
      },

      {
        path: "lov",
        loadChildren: () =>
          import("./pages/lov/lov.module").then((m) => m.LovModule),
        data: { breadcrumb: "lov"},
        canActivate: [AuthGuard],
      },
      {
        path: "icd10",
        loadChildren: () =>
          import("./pages/icd10/icd10.module").then((m) => m.ICD10Module),
        data: { breadcrumb: "icd10"},
        canActivate: [AuthGuard],
      },
      {
        path: "payer",
        loadChildren: () =>
          import("./pages/payer/payer.module").then((m) => m.PayerModule),
        data: { breadcrumb: "Payer" },
        canActivate: [AuthGuard],
      },
      {
        path: "location",
        loadChildren: () =>
          import("./pages/location/location.module").then(
            (m) => m.LocationModule
          ),
        data: { breadcrumb: "location" },
      },

      {
        path: "supportplanner",
        loadChildren: () =>
          import("./pages/supportplanner/supportplanner.module").then(
            (m) => m.SupportplannerModule
          ),
        data: { breadcrumb: "supportplanner"},
        canActivate: [AuthGuard],
      },
      {
        path: "vendor",
        loadChildren: () =>
          import("./pages/vendor/vendor.module").then(
            (m) => m.vendorModule
          ),
        data: { breadcrumb: "vendor"},
        canActivate: [AuthGuard],
      },

      {
        path: "user",
        loadChildren: () =>
          import("./pages/users/users.module").then((m) => m.UsersModule),
        data: { breadcrumb: "user"},
        canActivate: [AuthGuard],
      },
     
      {
        path: "agreementTemplate",
        loadChildren: () =>
          import("./pages/agreement-template/agreement-template.module").then(
            (m) => m.AgreementTemplateModule
          ),
        data: { breadcrumb: "template" },
        canActivate: [AuthGuard],
      },
      {
        path: "roles",
        loadChildren: () =>
          import("./pages/roles/roles.module").then((m) => m.RolesModule),
        data: { breadcrumb: "roles"},
        canActivate: [AuthGuard],
      },
      {
        path: "budgetimport",
        loadChildren: () =>
          import("./pages/budgetimport/budgetimport.module").then((m) => m.BudgetimportModule),
        data: { breadcrumb: "budgetimport"},
        canActivate: [AuthGuard],
      },
      {
        path: "report",
        loadChildren: () =>
          import("./pages/reports/reports.module").then((m) => m.ReportsModule),
        data: { breadcrumb: "report"},
        canActivate: [AuthGuard],
      },
     
      {
        path: "menus",
        loadChildren: () =>
          import("./pages/menus-new/menus-new.module").then(
            (m) => m.MenuNewModule
          ),
        data: { breadcrumb: "menus"},
        canActivate: [AuthGuard],
      },
      {
        path: "employee-agreementlist",
        loadChildren: () =>
          import(
            "./pages/employee-agreementlist/employee-agreementlist.module"
          ).then((m) => m.EmployeeAgreementlistModule),
        data: { breadcrumb: "employee-agreementlist" },
        canActivate: [AuthGuard],
      },
      {
        path: "client-onboarding-list",
        loadChildren: () =>
          import(
            "./pages/client-onboardinglist/client-onboardinglist.module"
          ).then((m) => m.clientOnboardingListModule),
        data: { breadcrumb: "client-onboarding-list"},
        canActivate: [AuthGuard],
      },

      {
        path: "purchase-list",
        loadChildren: () =>
          import(
            "./pages/purchase-request/purchase-request.module"
          ).then((m) => m.PurchaseRequestModule),
        data: { breadcrumb: "purchase-list" },
        canActivate: [AuthGuard],
      },
     

      {
        path: "timesheets",
        loadChildren: () =>
          import("./pages/timesheet/timesheet.module").then(
            (m) => m.TimesheetModule
          ),
        data: { breadcrumb: "timesheet"},
        canActivate: [AuthGuard],
      },
      {
        path: "timesheetVerification",
        loadChildren: () =>
          import("./pages/timesheetverification/timesheetverification.module").then(
            (m) => m.TimesheetverificationModule
          ),
        data: { breadcrumb: "timesheet-Verification"},
        canActivate: [AuthGuard],
      },

      {
        path: "transactions",
        loadChildren: () =>
          import("./pages/transaction-menu/transaction-menu.module").then(
            (m) => m.TransactionMenuModule
          ),
        data: { breadcrumb: "timesheet"},
        canActivate: [AuthGuard],
      },
      
      {
        path: "payor-mapping",
        loadChildren: () =>
          import("./pages/group-payor-mapping/group-payor-mapping.module").then(
            (m) => m.GroupPayorMappingModule
          ),
        data: { breadcrumb: "payormapping" },
        canActivate: [AuthGuard],
      },
      {
        path: "claims",
        loadChildren: () =>
          import("./pages/claims/claims.module").then(
            (m) => m.ClaimsModule
          ),
        data: { breadcrumb: "claims" },
        canActivate: [AuthGuard],
      },
      {
        path: "purchase-Verification",
        loadChildren: () =>
          import("./pages/purchase-verification/purchase-verification.module").then(
            (m) => m.PurchaseVerificationModule
          ),
        canActivate: [AuthGuard],
       
      },
      {
        path: "transaction-Verification",
        loadChildren: () =>
          import("./pages/transaction-verification/transaction-verification.module").then(
            (m) => m.TransactionVerificationModule
          ),
          canActivate: [AuthGuard],
       
      },
      {
        path: "importPayment",
        loadChildren: () =>
          import("./pages/import-payment/import-payment.module").then(
            (m) => m.ImportPaymentModule
          ),
        data: { breadcrumb: "claims"},
        canActivate: [AuthGuard],
      },
      {
        path: "transaction-logs",
        loadChildren: () =>
          import("./pages/transaction-logs/transaction-logs.module").then(
            (m) => m.TransactionLogsModule),
            canActivate: [AuthGuard],
       
      },
      {
        path: "caregiver-logs",
        loadChildren: () =>
          import("./pages/caregiver-logs/caregiver-logs.module").then(
            (m) => m.CaregiverLogsModule),
            
       
      },
      {
        path: "handbook",
        loadChildren: () =>
          import("./pages/handbook/handbook.module").then((m) => m.HandBookModule),
        canActivate: [AuthGuard],  
      
      },

      {
        path: "settings",
        loadChildren: () =>
          import("./pages/agency-settings/agency-settings.module").then((m) => m.AgencySettingsModule),
        data: { breadcrumb: "settings" },
        canActivate: [AuthGuard],
      },
      {
        path: "dynamicFormTemplate",
        loadChildren: () =>
          import("./pages/dynamicformtemplate/dynamicformtemplate.module").then((m) => m.DynamicFormTemplateModule),
        data: { breadcrumb: "dynamicFormTemplate" },
        canActivate: [AuthGuard],
      },

      {
        path: "client-employee-contact",
        loadChildren: () =>
          import("./pages/client-employee-contact/client-employee-contact.module").then((m) => m.ClientEmployeeContactModule),
        data: { breadcrumb: "dynamicFormTemplate"},
        canActivate: [AuthGuard],
      },

      
      {
        path: "client-employee-form",
        loadChildren: () =>
          import("./pages/client-employee-dynamicform/client-employee-dynamicform.module").then((m) => m.ClientEmployeeDynamicFormModule),
        data: { breadcrumb: "client-employee-dynamicform"},
        canActivate: [AuthGuard],  
      
      },
      {
        path: "serviceplan",
        loadChildren: () =>
          import("./pages/serviceplan/serviceplan.module").then((m) => m.ServiceplanModule),
        canActivate: [AuthGuard],  
      },

      {
        path: "serviceplanrate",
        loadChildren: () =>
          import("./pages/serviceplanrate/serviceplanrate.module").then((m) => m.ServiceplanRateModule),
        data: { breadcrumb: "serviceplanrate"},
        canActivate: [AuthGuard],
      },

      {
        path: "monitorlist",
        loadChildren: () =>
          import("./pages/monitorlist/monitorlist.module").then((m) => m.MonitorlistModule),
        data: { breadcrumb: "monitorlist"},
        canActivate: [AuthGuard],
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./pages/dashboard/dashboard.module").then((m) => m.DashboardModule),
        data: { breadcrumb: "dashboard" },
        canActivate: [AuthGuard],    
      },
      {
        path: "fmsagency",
        loadChildren: () =>
          import("./pages/fms-agency/fms-agency.module").then((m) => m.FmsAgencyModule),
        data: { breadcrumb: "fmsagency" },
        canActivate: [AuthGuard], 
      },
       {
        path: "homehealthagency",
        loadChildren: () =>
          import("./pages/home-health-agency/home-health-agency.module").then((m) => m.HomeHealthAgencyModule),
        // data: { breadcrumb: "homehealthagency" },
        // canActivate: [AuthGuard], 
      },
      {
        path: "admintime",
        loadChildren:()=>
          import("./pages/admin-time/admin-time.module").then((m) => m.AdminTimeModule),
        data: {breadcrumb : "admintime"},
        canActivate: [AuthGuard], 
      },
      {
        path:'engagement',
        loadChildren:()=>
          import('./pages/engagement/engagement.module').then((m) => m.EngagementModule),
        data: {breadcrumb: "engagement"},
        canActivate: [AuthGuard], 
        
      },
      {
        path:'ticket',
        loadChildren:()=>
          import('./pages/ticket/ticket.module').then((m) => m.TicketModule),
        data: {breadcrumb: "ticket"},
        canActivate: [AuthGuard], 
      },
      {
        path:'inbox',
        loadChildren:()=>
          import('./pages/inbox/inbox.module').then((m) => m.InboxModule),
        data: {breadcrumb: "ticket"},
        canActivate: [AuthGuard], 
      },
      {
        path: "authorization-logs",
        loadChildren: () =>
          import("./pages/authorizationlogs/authorizationlogs.module").then((m) => m.AuthorizationLogsModule),
        data: { breadcrumb: "authorization-logs" },
        canActivate: [AuthGuard], 
      },
      {
        path: "eligibility-logs",
        loadChildren: () =>
          import("./pages/eligibility-logs/eligibility-logs.module").then(
            (m) => m.EligibilityLogsModule),
            data: { breadcrumb: "eligibility-logs" },
            canActivate: [AuthGuard], 
      },
      {
        path: "calendar-schedule",
        loadChildren:()=>
          import("./pages/calendar-schedule/calendar-schedule.module").then((m) => m.CalendarScheduleModule),
        data: {breadcrumb : "calendar-schedule"},
        canActivate: [AuthGuard], 
        
      },
         {
        path: "splash",
        loadChildren:()=>
          import("./pages/splash/splash.module").then((m) => m.SplashModule),
        data: {breadcrumb : "splash"}
      },
   
     {
        path: "employee-reports",
        loadChildren: () =>
          import("./pages/employee-report/employee-report.module").then(
            (m) => m.EmployeeReportModule
          ),
        data: { breadcrumb: "/employee-reports"}
       
      },
         {
        path: "app-maintenance",
        loadChildren: () =>
          import("./pages/app-maintenance/app-maintenance.module").then(
            (m) => m.AppMaintenanceModule
          ),
        data: { breadcrumb: "/app-maintenance"}
       
      },
     ],
  },

  {
    path: "onboarding/client/:agencycode",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingModule
      ),
  },
  {
    path: "onboarding/employee/:agencycode",
    loadChildren: () =>
      import("./pages/onboarding/onboarding.module").then(
        (m) => m.OnboardingModule
      ),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("./pages/forgotpassword/forgotpassword.module").then(
        (m) => m.ForgotpasswordModule
      ),
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import("./pages/resetpassword/resetpassword.module").then(
        (m) => m.ResetpasswordModule
      ),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "password",
    loadChildren: () =>
      import("./pages/password/password.module").then((m) => m.PasswordModule),  
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.module").then((m) => m.RegisterModule),
  },
  {
        path: "employee-reports",
        loadChildren: () =>
          import("./pages/employee-report/employee-report.module").then(
            (m) => m.EmployeeReportModule
          ),
        data: { breadcrumb: "/employee-reports"}
       
      },
 
  { path: '**', component: PageNotMatchComponent }
  
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
function appRoutes(
  appRoutes: any,
  arg1: { preloadingStrategy: typeof PreloadAllModules }
) {
  throw new Error("Function not implemented.");
}

